module.exports = __webpack_public_path__ + "static/img/import.239b4b53.png";